import BasketSummaryResourceModel from '../../generated/types/model/resource/BasketSummaryResourceModel';

export default class BasketSummaryResourceViewModel extends BasketSummaryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
